module.exports = __webpack_public_path__ + "img/logo-green-black.eff029da.svg";